import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer if token in localStorage (fallback when cookies blocked)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("lf_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const detail = error.response?.data?.detail;
    error.userMessage = detail
      ? formatErrorDetail(detail)
      : error.response?.status
        ? `Request failed with status ${error.response.status}.`
        : "Network error. Please check your connection and try again.";
    return Promise.reject(error);
  }
);

export function formatErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtNGN(amount) {
  const n = Number(amount || 0);
  return "₦" + n.toLocaleString("en-NG", { maximumFractionDigits: 0 });
}
